export enum TicketTypeEnum {
  Ticket = "Ticket",
  SpaceTicket = "SpaceTicket",
  ComboTicket = "ComboTicket",
}
